(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["t-hhf-cows-flow"] && !Shopify.designMode) return;
  try {
    
  /* 生乳が届くまでの点線：画面の下から 2 割の所まで来た点を出す（戻しても消さない）。動きを減らす設定・テーマエディタでは最初から全部見せる */
  (() => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || (window.Shopify && Shopify.designMode)) return;
    document.querySelectorAll('.t-hhf-cows-flow').forEach((sec) => {
      const items = [...sec.querySelectorAll('.t-hhf-cows-flow__dots')].map((svg) => {
        const line = svg.querySelector('.t-hhf-cows-flow__dotline');
        const len = line.getTotalLength(), h = svg.viewBox.baseVal.height, N = 200;
        const ys = Array.from({ length: N + 1 }, (_, i) => line.getPointAtLength(len * i / N).y / h);
        if (svg.hasAttribute('data-reverse')) ys.reverse();       // 出す順（上から）にそろえる
        return { svg, ys, p: 0 };
      });
      if (!items.length) return;
      sec.classList.add('is-draw');
      let busy = false;
      const update = () => {
        busy = false;
        const limit = innerHeight * 0.8;
        items.forEach((it) => {
          const r = it.svg.getBoundingClientRect();
          if (!r.height) return;
          let k = 0;
          while (k < it.ys.length && r.top + it.ys[k] * r.height <= limit) k++;
          const p = k ? (k - 1) / (it.ys.length - 1) : 0;
          if (p > it.p) { it.p = p; it.svg.style.setProperty('--p', p); if (p >= 1) setTimeout(() => it.svg.classList.add('is-done'), 500); }
        });
        if (items.every((it) => it.p >= 1)) { removeEventListener('scroll', onScroll); removeEventListener('resize', onScroll); }
      };
      const onScroll = () => { if (!busy) { busy = true; requestAnimationFrame(update); } };
      addEventListener('scroll', onScroll, { passive: true });
      addEventListener('resize', onScroll);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["t-hhf-top-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('t-hhf-gallery')) {
    customElements.define('t-hhf-gallery', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.t-hhf-top-gallery__slide'));
        this.thumbs = Array.from(this.querySelectorAll('.t-hhf-top-gallery__thumb'));
        this.current = 0;
        this.token = 0;
        this.addEventListener('click', (e) => {
          const thumb = e.target.closest('.t-hhf-top-gallery__thumb');
          const arrow = e.target.closest('.t-hhf-top-gallery__arrow');
          if (thumb) this.show(Number(thumb.dataset.index));
          if (arrow) this.show(this.current + Number(arrow.dataset.dir));
          if (thumb || arrow) this.restart();
        });
        // ギャラリーが画面に近づいたら、全部の写真を先に読み込んでおく（遅延読み込みのままだと切り替えた瞬間に読み始めて白くなる）
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((en) => {
            this.visible = en.isIntersecting;
            if (en.isIntersecting && !this.loaded) {
              this.loaded = true;
              this.slides.forEach((s) => s.querySelectorAll('img').forEach((img) => { img.loading = 'eager'; }));
            }
          });
          this.restart();
        }, { rootMargin: '300px 0px' });
        this.io.observe(this);
        this.delay = Number(this.dataset.autoplay) || 0;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.delay = 0;
        this.addEventListener('mouseenter', () => { this.paused = true; this.restart(); });
        this.addEventListener('mouseleave', () => { this.paused = false; this.restart(); });
        this.addEventListener('focusin', () => { this.paused = true; this.restart(); });
        this.addEventListener('focusout', () => { this.paused = false; this.restart(); });
        document.addEventListener('visibilitychange', () => this.restart());
      }
      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        clearTimeout(this.timer);
      }
      restart() {
        clearTimeout(this.timer);
        if (!this.delay || !this.visible || this.paused || this.slides.length < 2 || document.hidden) return;
        this.timer = setTimeout(() => this.show(this.current + 1).then(() => this.restart()), this.delay);
      }
      async show(i) {
        const total = this.slides.length;
        if (!total) return;
        const next = (i + total) % total;
        const token = ++this.token;
        const img = this.slides[next].querySelector('img');
        if (img) {
          img.loading = 'eager';
          // 読み終わるまで今の写真を出したまま待つ
          try { await img.decode(); } catch (e) { /* 読めなくても切り替える */ }
        }
        if (token !== this.token) return; // 待っている間に別の写真が押された
        this.current = next;
        this.slides.forEach((s) => {
          const on = Number(s.dataset.index) === this.current;
          s.classList.toggle('is-active', on);
          if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        });
        this.thumbs.forEach((t) => {
          if (Number(t.dataset.index) === this.current) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["t-main-product"]) return;
  try {
    
document.addEventListener('change', (e) => {
  const select = e.target.closest('[data-t-variant]');
  if (!select) return;
  const root = select.closest('[data-t-product]');
  const opt = select.selectedOptions[0];
  const now = root.querySelector('.t-price__now');
  const was = root.querySelector('.t-price__was');
  if (now) now.textContent = opt.dataset.price;
  if (was) was.textContent = opt.dataset.compare || '';
  const add = root.querySelector('[data-t-add]');
  if (add) {
    const ok = opt.dataset.available === 'true';
    add.disabled = !ok;
    add.querySelector('span').textContent = ok ? (add.dataset.label || add.querySelector('span').textContent) : '売り切れ';
  }
  const url = new URL(window.location.href);
  url.searchParams.set('variant', select.value);
  window.history.replaceState({}, '', url);
});

  } catch(e) { console.error(e); }
})();
})();
